import { Renderer2 } from '@angular/core';

interface HasChildren<T> {
  children?: T[]
}

interface HasItemId<T> extends HasChildren<T> {
  itemId: number
}

export function forEachTreeNode<T extends HasChildren<T>>(nodes: T[], callbackFn: (node: T, parent?: T) => any, parent?: T): void {
  for (const node of nodes) {
    callbackFn(node, parent)

    if (node.children)
      forEachTreeNode(node.children, callbackFn, node)
  }
}

// Find TreeNode by ItemId and return first match
export function findTreeNode<T extends HasItemId<T>>(nodes: T[], itemId: number): T | null {
  for (const node of nodes) {
    if (node.itemId === itemId)
      return node

    if (node.children) {
      const childResult = findTreeNode(node.children, itemId)
      if (childResult)
        return childResult
    }
  }

  return null
}

// Find all TreeNodes matching the selector
export function findTreeNodes<T extends HasItemId<T>>(nodes: T[], selector: (node: T) => boolean): T[] {
  const result: T[] = []

  for (const node of nodes) {
    if (selector(node))
      result.push(node)

    if (node.children)
      findTreeNodes(node.children, selector)
  }

  return result
}

export function onMenuTreeOpen(renderer: Renderer2): void {
  renderer.addClass(document.body, 'has-matmenu-tree')
}
export function onMenuTreeClose(renderer: Renderer2): void {
  renderer.removeClass(document.body, 'has-matmenu-tree')
}
